import React, { useEffect, useState } from 'react';

import { useFreecodeContextData } from 'hooks/useContext';
import { FreecodeButton, ButtonsContainer } from 'components/Button/RectangleButton';
import { ButtonIcon } from 'components/Button/styles';
import ApiListItemDisplay from './ApiListItemDisplay';
import ResetImplementation from './ResetImplementation';
import RegenerateSkeletons from './RegenerateSkeletons';
import ResetSolution from './ResetSolution';
import EditApiModal from './EditApiModal';
import { genChallengeMethodsFull, genSolutionMethodsFull } from './processApi';
import { CreatorSection, CreatorTabColumnContainer, CreatorTabContentBackground, Text } from '../styles';
import { ErrorMessage } from './styles';

const DefaultEditApiModalData = { isOpen: false, apiType: 'solution', apiMethod: null, index: -1 };

export default function FreecodeApiSettings() {
  const { testImpl } = useFreecodeContextData();

  const [challengeApi, setChallengeApi] = useState([]);
  const [solutionApi, setsolutionApi] = useState([]);
  const [modalOpenCount, setModalOpenCount] = useState(0);

  useEffect(() => {
    if (!testImpl?.api) return;
    setChallengeApi(genChallengeMethodsFull(testImpl.api, testImpl.generated?.apiStrings, 'python'));
    setsolutionApi(genSolutionMethodsFull(testImpl.api, testImpl.generated?.apiStrings, 'python'));
  }, [testImpl]);

  const [editApiModalData, setEditApiModalData] = useState(DefaultEditApiModalData);

  const openApiMethodModal = (apiType, apiMethod = null, index = -1) => {
    setModalOpenCount((value) => value + 1);
    setEditApiModalData({ isOpen: true, apiType, apiMethod, index });
  };

  const closeApiMethodModal = () => setEditApiModalData(DefaultEditApiModalData);

  return (
    <CreatorTabContentBackground>
      <CreatorSection>
        <CreatorTabColumnContainer>
          <Text>Unsaved changes might be discarded when modifying the API.</Text>
        </CreatorTabColumnContainer>
      </CreatorSection>
      <CreatorSection>
        <ButtonsContainer>
          <FreecodeButton small isFreecodeButton onClick={() => openApiMethodModal('challenge')}>
            <ButtonIcon icon="fa fa-plus" /> Add Implementation API
          </FreecodeButton>
          <ResetImplementation />
        </ButtonsContainer>

        {challengeApi.map((apiMethod, index) => (
          <ApiListItemDisplay
            key={`${modalOpenCount}-${index}-${apiMethod.name}`}
            index={index}
            apiType="challenge"
            apiMethod={apiMethod}
            onClickEdit={() => openApiMethodModal('challenge', apiMethod, index)}
          />
        ))}

        {testImpl.enableSkeletonEditing && (
          <ErrorMessage>Solution API editing disabled since this implementation has custom skeletons</ErrorMessage>
        )}

        <ButtonsContainer>
          <FreecodeButton
            small
            isFreecodeButton
            onClick={() => openApiMethodModal('solution')}
            disabled={testImpl.enableSkeletonEditing}
          >
            <ButtonIcon icon="fa fa-plus" /> Add Solution API
          </FreecodeButton>
          <ResetSolution />
          <RegenerateSkeletons />
        </ButtonsContainer>

        {solutionApi.map((apiMethod, index) => (
          <ApiListItemDisplay
            key={`${modalOpenCount}-${index}-${apiMethod.name}`}
            index={index}
            apiType="solution"
            apiMethod={apiMethod}
            onClickEdit={() => openApiMethodModal('solution', apiMethod, index)}
            disabled={testImpl.enableSkeletonEditing}
          />
        ))}

        {/* Create or edit api modal */}
        {editApiModalData.isOpen && (
          <EditApiModal
            index={editApiModalData.index}
            apiMethod={editApiModalData.apiMethod}
            apiType={editApiModalData.apiType}
            closeModal={closeApiMethodModal}
          ></EditApiModal>
        )}
      </CreatorSection>
    </CreatorTabContentBackground>
  );
}
